import LinkButton from "components/ui/LinkButton"
import styles from "./BackwardsNav.module.scss"
import cn from "classnames"

const BackwardsNav = ({ locale, url, text, isLightBackground }) => {
  return (
    <div
      className={cn(styles.nav, {
        [styles[`BackwardsNav--${locale}`]]: locale,
      })}
    >
      <LinkButton
        className={cn(styles.navButton, {
          [styles.invertText]: isLightBackground,
        })}
        iconClassName="rotate-180"
        data={{
          link_url: url,
          link_text: text,
          show_arrow: true,
        }}
      />
    </div>
  )
}

export default BackwardsNav
